import React from "react";
import {
  Row,
  Col,
  Form,
  FormInput,
  FormGroup,
  Button,
  FormTextarea,
  FormFeedback,
} from "shards-react";
import { useFormik } from "formik";
import { SelectAgency } from "shared/components";
import { ToastContainer, toast } from "react-toastify";
import { useTranslation } from "react-i18next";

import baseUrl from "config/baseUrl";

const axios = require("axios").default;
const ContactForm = () => {
  const { t, i18n } = useTranslation();

  const showNotify = (message, type) => {
    switch (type) {
      case "success":
        toast.success(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "error":
        toast.error(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "warn":
        toast.warn(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "info":
        toast.info(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      default:
        toast.success(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
    }
  };
  const validate = (values) => {
    const errors = {};
    if (!values.username) {
      errors.username = t("common:contact.PleaseEnterNameSurname");
    }

    if (!values.questionnaireEmail) {
      errors.questionnaireEmail = t("common:contact.PleaseEnterEmail");
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
        values.questionnaireEmail
      )
    ) {
      errors.questionnaireEmail = "Invalid email address";
    }

    if (!values.questionnairePhone) {
      errors.questionnairePhone = t("common:contact.PleaseEnterTel");
    } else if (values.questionnairePhone.length < 10) {
      errors.questionnairePhone = t("common:contact.PleaseEnterValidNumber");
    }
    if (!values.agencyId) {
      errors.agencyId = t("common:contact.PleaseEnterAgency");
    } else if (values.agencyId === "0") {
      errors.agencyId = t("common:contact.PleaseEnterAgency");
    }
    if (!values.questionnaireHeadTopic) {
      errors.questionnaireHeadTopic = t("common:contact.PleaseEnterTopic");
    }
    if (!values.questionnaireTopic) {
      errors.questionnaireTopic = t("common:contact.PleaseEnterDescription");
    }
    return errors;
  };
  const formik = useFormik({
    initialValues: {
      username: "",
      questionnaireFname: "",
      questionnaireLname: "",
      agencyId: null,
      questionnairePhone: "",
      questionnaireHeadTopic: "",
      questionnaireTopic: "",
      questionnaireEmail: "",
    },
    validate,
    onSubmit: (values, { resetForm }) => {
      var splitName = values.username.split(" ");
      if (splitName.length > 1) {
        values.questionnaireFname = splitName[0];
        values.questionnaireLname = splitName[1];
      } else {
        values.questionnaireFname = splitName[0];
      }
      const sendobject = {
        agencyId: values.agencyId,
        questionnaireEmail: values.questionnaireEmail,
        questionnaireFname: values.questionnaireFname,
        questionnaireHeadTopic: values.questionnaireHeadTopic,
        questionnaireLname: values.questionnaireLname,
        questionnaireTopic: values.questionnaireTopic,
        questionnairePhone: values.questionnairePhone,
      };
      axios
        .post(`${baseUrl}/v1/setting/createquestionnaire`, sendobject)
        .then(function(response) {
          showNotify(t("common:contact.submitSuccessfully"));
          resetForm();
          // window.location = "/";
        })
        .catch(function(error) {
          if (error.response.data.message) {
            showNotify(error.response.data.message, "error");
          } else {
            showNotify(error.message, "error");
          }
        });
    },
  });
  return (
    <>
      <ToastContainer />
      <Row>
        <Col>
          <Form onSubmit={formik.handleSubmit}>
            <Row>
              <Col md="6">
                <FormGroup>
                  <label>
                    {t("common:contact.NameSurname")}
                    <span className="color-red">*</span>
                  </label>
                  <FormInput
                    type="text"
                    name="username"
                    placeholder={t("common:contact.NameSurname")}
                    onChange={formik.handleChange}
                    invalid={!!formik.errors.username}
                    value={formik.values.username}
                  />
                  {formik.errors.username && (
                    <FormFeedback>{t("common:contact.PleaseEnterNameSurname")}</FormFeedback>
                  )}
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <label>
                    {t("common:contact.Email")}
                    <span className="color-red">*</span>
                  </label>
                  <FormInput
                    type="email"
                    name="questionnaireEmail"
                    placeholder={t("common:contact.Email")}
                    onChange={formik.handleChange}
                    invalid={!!formik.errors.questionnaireEmail}
                    value={formik.values.questionnaireEmail}
                  />
                  {formik.errors.questionnaireEmail && (
                    <FormFeedback>
                      {t("common:contact.PleaseEnterEmail")}
                    </FormFeedback>
                  )}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <FormGroup>
                  <label>
                    {t("common:contact.Tel")}
                    <span className="color-red">*</span>
                  </label>
                  <FormInput
                    type="tel"
                    name="questionnairePhone"
                    placeholder={t("common:contact.Tel")}
                    onChange={formik.handleChange}
                    invalid={!!formik.errors.questionnairePhone}
                    value={formik.values.questionnairePhone}
                  />
                  {formik.errors.questionnairePhone && (
                    <FormFeedback>
                     {t("common:contact.PleaseEnterTel")}
                    </FormFeedback>
                  )}
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <label>
                    {t("common:contact.Agency")}
                    <span className="color-red">*</span>
                  </label>
                  <SelectAgency
                    placeholder={t("common:contact.Select")}
                    name="agencyId"
                    onChange={(e) => {
                      const id = e.nativeEvent.target.selectedIndex;
                      formik.handleChange(e);
                    }}
                    value={formik.values.agencyId}
                    invalid={!!formik.errors.agencyId}
                    typeId={formik.values.agencyTypeId}
                    onBlur={formik.handleBlur}
                  />
                  {formik.errors.agencyId && (
                    <FormFeedback>{t("common:contact.PleaseEnterAgency")}</FormFeedback>
                  )}
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md="6">
                <FormGroup>
                  <label>
                    {t("common:contact.Topic")}
                    <span className="color-red">*</span>
                  </label>
                  <FormInput
                    type="text"
                    name="questionnaireHeadTopic"
                    placeholder={t("common:contact.Topic")}
                    onChange={formik.handleChange}
                    invalid={!!formik.errors.questionnaireHeadTopic}
                    value={formik.values.questionnaireHeadTopic}
                  />
                  {formik.errors.questionnaireHeadTopic && (
                    <FormFeedback>
                      {t("common:contact.PleaseEnterTopic")}
                    </FormFeedback>
                  )}
                </FormGroup>
              </Col>
            </Row>

            <FormGroup>
              <label>
                {t("common:contact.Description")}
                <span className="color-red">*</span>
              </label>
              <FormTextarea
                name="questionnaireTopic"
                onChange={formik.handleChange}
                value={formik.values.questionnaireTopic}
                invalid={!!formik.errors.questionnaireTopic}
                placeholder={t("common:contact.Description")}
              />

              {formik.errors.questionnaireTopic && (
                <FormFeedback>{t("common:contact.PleaseEnterDescription")}</FormFeedback>
              )}
            </FormGroup>

            <Button
              type="submit"
              className="btn-success pull-right"
              style={{ float: "right", width: 200 }}
            >
              {t("common:contact.Send")}
            </Button>
          </Form>
        </Col>
      </Row>
    </>
  );
};
export default ContactForm;
